import { Object3D, Vector2, Vector3 } from 'three';
import { BUTTON_PRIMARY_COLOR, BUTTON_PRIMARY_TEXT_COLOR, PRIMARY_TEXT_COLOR, WINDOW_SPACER_COLOR } from '../styleConfig';
import { FuturisticWindow } from './FuturisticWindow';
import { ActionControllerEventName, ButtonComponent, ParentEvent, TextComponent, Tween, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
export default class WelcomeScreen extends ViewerModule {
    constructor() {
        super();
        this.addObject(this.background = new FuturisticWindow({
            size: new Vector2(8.45, 5),
            radius: 0.3,
            type: 3,
            hasSideImage: true
        }));
        this.addObject(this.header = new TextComponent({
            size: new Vector2(1.1, 1.1 / 2),
            pxSize: new Vector2(64, 64 / 2).multiplyScalar(window['quality'] === 'very low' ? 1 : 1),
            text: {
                style: {
                    size: `${34 * (window['quality'] === 'very low' ? 1 : 1)}px`,
                    family: 'Nunito',
                    weight: '800',
                    color: PRIMARY_TEXT_COLOR.getStyle()
                },
                lineHeight: 40 * (window['quality'] === 'very low' ? 1 : 1),
                value: '',
                autoWrappingHorizontal: true,
                margin: { bottom: 18 }
            },
            background: { color: 'transparent' }
        }));
        this.header.uiObject.position.set(0, 1.4, 0.01);
        this.addObject(this.text = new TextComponent({
            size: new Vector2(8, 1),
            pxSize: new Vector2(512, 64).multiplyScalar(window['quality'] === 'very low' ? 1 : 1),
            text: {
                style: {
                    size: `${22 * (window['quality'] === 'very low' ? 1 : 1)}px`,
                    family: 'Nunito',
                    weight: '400',
                    color: PRIMARY_TEXT_COLOR.getStyle()
                },
                value: '',
                autoWrappingHorizontal: false,
                lineHeight: 26 * (window['quality'] === 'very low' ? 1 : 1),
                align: 'center',
                autoWrapping: true,
                margin: { bottom: 18 }
            },
            background: { color: WINDOW_SPACER_COLOR.getStyle() }
        }));
        this.text.uiObject.position.y = -0.3;
        this.text.uiObject.position.z = 0.01;
        this.addObject(this.button = new ButtonComponent({
            type: 'flat',
            size: new Vector3(6, 6, 1),
            sizePx: new Vector2(256, 256).multiplyScalar(window['quality'] === 'very low' ? 1 : 1),
            bordRadius: 0.1,
            background: { color: BUTTON_PRIMARY_COLOR.getStyle() },
            text: {
                value: 'Start'.toUpperCase(),
                lineHeight: 12 * (window['quality'] === 'very low' ? 1 : 1),
                style: {
                    size: `${16 * (window['quality'] === 'very low' ? 1 : 1)}px`,
                    color: BUTTON_PRIMARY_TEXT_COLOR.getStyle(),
                    family: 'Nunito',
                    weight: '800'
                },
                margin: { top: 10, right: 45, bottom: 10, left: 45 },
            }
        }));
        this.button.on(ActionControllerEventName.click, () => this.fire('buttonClick'));
        this.button.on(ActionControllerEventName.click, () => this.fire('ok', new ParentEvent('ok')));
        this.addObject(this.secondButton = new ButtonComponent({
            type: 'flat',
            size: new Vector3(6, 6, 1),
            sizePx: new Vector2(256, 256).multiplyScalar(window['quality'] === 'very low' ? 1 : 1),
            bordRadius: 0.1,
            background: { color: BUTTON_PRIMARY_COLOR.getStyle() },
            text: {
                value: 'Start'.toUpperCase(),
                lineHeight: 12 * (window['quality'] === 'very low' ? 1 : 1),
                style: {
                    size: `${16 * (window['quality'] === 'very low' ? 1 : 1)}px`,
                    color: BUTTON_PRIMARY_TEXT_COLOR.getStyle(),
                    family: 'Nunito',
                    weight: '800'
                },
                margin: { top: 10, right: 45, bottom: 10, left: 45 },
            }
        }));
        this.secondButton.on(ActionControllerEventName.click, () => this.fire('secondButtonClick'));
        this.buttonsWrapper = new Object3D();
        this.buttonsWrapper.position.set(0, -1.75, 0.01);
        this.addObject(this.buttonsWrapper);
    }
    init(headerText, mainText, buttonText, secondButtonText) {
        // console.log('==========WelcomeScreen==========' + headerText);
        this.background.init();
        this.header.setText(headerText);
        this.text.setText(mainText);
        this.button.setText(buttonText.toUpperCase());
        if (secondButtonText) {
            this.secondButton.setText(secondButtonText.toUpperCase());
        }
        if (secondButtonText) {
            if (this.button.uiObject.parent)
                this.button.uiObject.parent.remove(this.button.uiObject);
            if (this.secondButton.uiObject.parent)
                this.secondButton.uiObject.parent.remove(this.secondButton.uiObject);
            this.button.options.text.margin = { top: 10, right: 15, bottom: 10, left: 15 };
            this.button.updateElement(this.button.options);
            this.secondButton.options.text.margin = { top: 10, right: 15, bottom: 10, left: 15 };
            this.secondButton.updateElement(this.secondButton.options);
            this.buttonsWrapper.add(this.button.uiObject);
            this.buttonsWrapper.add(this.secondButton.uiObject);
        }
        else if (buttonText) {
            if (this.button.uiObject.parent)
                this.button.uiObject.parent.remove(this.button.uiObject);
            if (this.secondButton.uiObject.parent)
                this.secondButton.uiObject.parent.remove(this.secondButton.uiObject);
            this.button.options.text.margin = { top: 10, right: 45, bottom: 10, left: 45 };
            this.button.updateElement(this.button.options);
            this.buttonsWrapper.add(this.button.uiObject);
        }
        else {
            if (this.button.uiObject.parent)
                this.button.uiObject.parent.remove(this.button.uiObject);
            if (this.secondButton.uiObject.parent)
                this.secondButton.uiObject.parent.remove(this.secondButton.uiObject);
        }
        this.uiObject.remove(this.buttonsWrapper);
        this.buttonsWrapper.updateMatrixWorld(true);
        ViewerModule.adjustObjects(this.buttonsWrapper.children, true, 0.5);
        this.uiObject.add(this.buttonsWrapper);
    }
    flyTo(pos, time = 1, onComplete) {
        let flyAnim = new Tween(this.uiObject.position)
            .to(pos.clone(), time)
            .easing(TWEEN.Easing.Linear.None)
            .onUpdate((delta) => {
            this.uiObject.lookAt(Viewer.controls.target.clone());
        })
            .onComplete(() => {
            console.log('fly end');
            this.uiObject.lookAt(Viewer.controls.target.clone());
            // flyAnim.stop();
            onComplete && onComplete();
        })
            .start();
    }
    show(isVisible = true) {
        this.uiObject.visible = isVisible;
    }
}
